import React from "react";
import { connect } from "react-redux";
// import { Link } from "react-router-dom";

// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './draftEditResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'
import ShowJson from "../ShowJson";


export class DraftEditResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            selectedLogData: null // To store the JSON data for ShowJson   

        }

    }


    getOutboundLogData = () => {

        let sortedArray = this.props.draftEditLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];


        sortedArray.forEach((entry) => {
            let changedParams = {}
            let oldparams = JSON.parse(entry.OldParameters)
            let newparams = JSON.parse(entry.Parameters)
            Object.keys(oldparams).forEach((key) => {
                if (oldparams[key] !== newparams[key]) {
                    console.log(key)
                    changedParams[key] = {
                        old: oldparams[key],
                        new: newparams[key]
                    }
                }
            })

            changedParams = JSON.stringify(changedParams)

            JSX.push(<tr className="DraftEditResult-value" key={entry.id}>
                <td className="DraftEditResult-date-value">{entry.InsertedOn.split('.')[0].replace('T', ' ')}</td>
                <td>{entry.ScheduledID}</td>

                <td>
                    <button className="show-params-button" onClick={() => {
                        let jsonData;
                        try {
                            jsonData = JSON.parse(entry.OldParameters); // Try parsing the JSON

                            jsonData=entry.OldParameters;
                        } catch (e) {
                            jsonData = JSON.stringify({ "message": "No Result Available" }); // Fallback if not valid JSON
                        }
                        this.setState({ selectedLogData: jsonData });
                    }}>
                        Show OldParameters
                    </button>
                </td>
                
                <td>
                    <button className="show-params-button" onClick={() => {
                        let jsonData;
                        try {
                            jsonData = JSON.parse(entry.Parameters); // Try parsing the JSON

                            jsonData=entry.Parameters;
                        } catch (e) {
                            jsonData = JSON.stringify({ "message": "No Result Available" }); // Fallback if not valid JSON
                        }
                        this.setState({ selectedLogData: jsonData });
                    }}>
                        Show NewParameters
                    </button>
                </td>
                
                <td>
                    <button className="show-params-button" onClick={() => {
                        let jsonData;
                        try {
                            jsonData = JSON.parse(changedParams); // Try parsing the JSON

                            jsonData=changedParams;
                        } catch (e) {
                            jsonData = JSON.stringify({ "message": "No Result Available" }); // Fallback if not valid JSON
                        }
                        this.setState({ selectedLogData: jsonData });
                    }}>
                        Changed Parameters
                    </button>
                </td>
            </tr>)
        })

        return JSX;

    }

    moveNextPage = () => {
        if (this.state.currentPage < this.props.maxPage) {
            this.setState({ currentPage: this.state.currentPage + 1 })
        }
    }
    movePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 })
        }
    }

    conditionalRendering = () => {
        
        if (this.state.selectedLogData) {
            return (<ShowJson jsonData={this.state.selectedLogData} onClose={() => this.setState({ selectedLogData: null })} />);
        }
        if (this.props.draftEditLogs) {
            return (<div className="DraftEditResult">

                <div className="DraftEditResult-log-details-container">
                    <table className="DraftEditResult-log-details">
                        <thead>
                            <tr>
                                <th className="DraftEditResult-date">Date</th>
                                <th className="DraftEditResult-schedule">ScheduledID</th>
                                <th className="DraftEditResult-oldparams">Old Parameters</th>
                                <th className="DraftEditResult-newparams">New Parameters</th>
                                <th className="DraftEditResult-changedparams">Changed Parameters</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getOutboundLogData(this.state.currentPage)}
                        </tbody>
                    </table>
                </div>
                <div className="DraftEditResult-pagination">
                    <div className="DraftEditResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="DraftEditResult-pagination-buttongroup">
                        <button className="DraftEditResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="DraftEditResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.draftEditLogs.logs && state.logs.draftEditLogs.logs.length) {
        //showing 25 entries max per page
        return { draftEditLogs: state.logs.draftEditLogs.logs, maxPage: state.logs.draftEditLogs.logs.length % 25 === 0 ? state.logs.draftEditLogs.logs.length / 25 : Math.ceil(state.logs.draftEditLogs.logs.length / 25) };
    } else {
        return { draftEditLogs: null, maxPage: 1 }
    }
};

export default connect(mapStateToProps)(DraftEditResult);
